import { MAP_getInstance3e78m6vf98i66 as MAP_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Selectorispogzpkkfxv as Selector } from './Selector.mjs';
import { toMutableMapr5f3w62lv8sk as toMutableMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { default1jaun537xukbl as default_0 } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Defaults.mjs';
import { await1uwe8zvsjq69o as await_0 } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import {
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
  Signal1973xs1vkmdcb as Signal,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  mapKeyElement31sqd0eg9e6zl as mapKeyElement,
  mapValueElementnslktw4l3iup as mapValueElement,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { RenderContextxikz99gtpuie as RenderContext } from './RenderContext.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  get_px8ok5q0jdway2 as get_px,
  get_rem2p56fiaxda5jo as get_rem,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  weight31wqab1913ly4 as weight,
  textPopover3tarprbgmgxbr as textPopover,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { subrendererSelector1yvbedolu35d3 as subrendererSelector } from './helpers.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_shown_$ref_kipsub2u3yvjqlogkp3 as TextView$_get_shown_$ref_kipsub,
  TextView$_set_shown_$ref_l7jsq921p8dnwznnah1 as TextView$_set_shown_$ref_l7jsq9,
} from './CsvRenderer.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  ListSemantic_getInstance2e62q1se6gw64 as ListSemantic_getInstance,
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  subtext2yjmf1ok7kb40 as subtext,
  h42yee57ysxgrns as h4,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { Companion_getInstance23x6zslwzj0st as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  TextView$_get_content_$ref_4pzcwl1tl9xt9sj2eem as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfbq6gzmblx5q7v as TextView$_set_content_$ref_pketfb,
} from '../auth/EmailProofComponent.mjs';
import {
  cellFormub3o1hqp20e5 as cellForm,
  Renderer1fhwti5gmwutm as Renderer,
} from './Renderer.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function registerMap(_this__u8e3s4) {
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, VOID, MAP_getInstance()), MapRenderer_instance);
}
function MapRenderer$form$lambda$lambda$lambda($entryKey) {
  return (it) => $entryKey;
}
function MapRenderer$form$lambda$lambda$lambda_0($entryKey, $entryValue) {
  return (original, newKey) => {
    var tmp;
    if (!equals(newKey, $entryKey)) {
      var result = toMutableMap(original);
      result.remove_gppy8k_k$($entryKey);
      var tmp0_elvis_lhs = original.get_wei43m_k$($entryKey);
      // Inline function 'kotlin.collections.set' call
      var value = tmp0_elvis_lhs == null ? $entryValue : tmp0_elvis_lhs;
      result.put_4fpzoq_k$(newKey, value);
      tmp = result;
    } else {
      tmp = original;
    }
    return tmp;
  };
}
function MapRenderer$form$lambda$lambda$lambda_1($entryValue) {
  return (it) => $entryValue;
}
function MapRenderer$form$lambda$lambda$lambda_2($entryKey) {
  return (original, newValue) => {
    var result = toMutableMap(original);
    // Inline function 'kotlin.collections.set' call
    var key = $entryKey;
    result.put_4fpzoq_k$(key, newValue);
    return result;
  };
}
function MapRenderer$form$lambda$lambda$lambda_3($$this$col, $selectedKeyRenderer, $keyContext, $keyLens, $module) {
  return ($this$reactive) => {
    $$this$col.clearChildren_eufjq4_k$();
    $this$reactive.invoke_r7m7el_k$($selectedKeyRenderer).form_gie6yk_k$($keyContext, $keyLens, $module)($$this$col);
    return Unit_instance;
  };
}
function MapRenderer$form$lambda$lambda$lambda_4($$this$col, $selectedValueRenderer, $valueContext, $valueLens, $module) {
  return ($this$reactive) => {
    $$this$col.clearChildren_eufjq4_k$();
    $this$reactive.invoke_r7m7el_k$($selectedValueRenderer).form_gie6yk_k$($valueContext, $valueLens, $module)($$this$col);
    return Unit_instance;
  };
}
function MapRenderer$form$lambda$lambda$slambda($this_reactive, $value, $keyToRemove) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    var result = toMutableMap($this_reactive.invoke_r7m7el_k$($value));
    result.remove_gppy8k_k$($keyToRemove);
    yield* $value.set_revjhg_k$(result, $completion);
    return Unit_instance;
  }), 0);
}
function MapRenderer$form$lambda$slambda($keySerializer, $valueSerializer, $value) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    var defaultKey = default_0($keySerializer);
    var defaultValue = default_0($valueSerializer);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $value;
    var tmp$ret$0 = yield* await_0(this_0, $completion);
    var newMap = toMutableMap(tmp$ret$0);
    // Inline function 'kotlin.collections.set' call
    newMap.put_4fpzoq_k$(defaultKey, defaultValue);
    yield* $value.set_revjhg_k$(newMap, $completion);
    return Unit_instance;
  }), 0);
}
function MapRenderer$view$lambda$lambda$lambda($$this$col, $selectedKeyRenderer, $keyContext, $key, $module) {
  return ($this$reactive) => {
    $$this$col.clearChildren_eufjq4_k$();
    $this$reactive.invoke_r7m7el_k$($selectedKeyRenderer).view_bqdmap_k$($keyContext, new (Constant())(_Constant___init__impl__v45mub($key)), $module)($$this$col);
    return Unit_instance;
  };
}
function MapRenderer$view$lambda$lambda$lambda_0($$this$col, $selectedValueRenderer, $valueContext, $entryValue, $module) {
  return ($this$reactive) => {
    $$this$col.clearChildren_eufjq4_k$();
    $this$reactive.invoke_r7m7el_k$($selectedValueRenderer).view_bqdmap_k$($valueContext, new (Constant())(_Constant___init__impl__v45mub($entryValue)), $module)($$this$col);
    return Unit_instance;
  };
}
var MapRendererClass;
function MapRenderer() {
  if (MapRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Key-Value Pairs';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      priority_vs5rr7_k$(context, module_0) {
        return equals(context.serializer_1.get_descriptor_wjt6a0_k$().get_kind_wop7ml_k$(), MAP_getInstance()) ? 0.8 : -1.0;
      }
      priority_yxj3hb_k$(context, module_0) {
        return this.priority_vs5rr7_k$(context, module_0);
      }
      form_s1o4lc_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          var tmp = mapKeyElement(context.serializer_1);
          var keySerializer = (!(tmp == null) ? isInterface(tmp, KSerializer()) : false) ? tmp : THROW_CCE();
          var tmp_0 = mapValueElement(context.serializer_1);
          var valueSerializer = (!(tmp_0 == null) ? isInterface(tmp_0, KSerializer()) : false) ? tmp_0 : THROW_CCE();
          var keyContext = new (RenderContext())(keySerializer);
          var valueContext = new (RenderContext())(valueSerializer);
          var keyRenderers = module_0.selectAll_bhj9zi_k$(keyContext);
          var valueRenderers = module_0.selectAll_bhj9zi_k$(valueContext);
          var selectedKeyRenderer = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(module_0.selectWithOverride_muco3f_k$(keyContext));
          var selectedValueRenderer = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(module_0.selectWithOverride_muco3f_k$(valueContext));
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          element.set_gap_jwjroq_k$(get_px(0));
          if (module_0.enableRendererSwitching_1) {
            // Inline function 'com.lightningkite.kiteui.views.direct.row' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
            ensureOutermostElement(element_0);
            element.willAddChild_hz2iwc_k$(element_0);
            element_0.set_vertical_nuap32_k$(false);
            // Inline function 'com.lightningkite.kiteui.views.expanding' call
            var tmp$ret$8 = weight(element_0, 1.0);
            subrendererSelector(tmp$ret$8, selectedKeyRenderer, keyRenderers);
            // Inline function 'com.lightningkite.kiteui.views.expanding' call
            var tmp$ret$9 = weight(element_0, 1.0);
            subrendererSelector(tmp$ret$9, selectedValueRenderer, valueRenderers);
            element_0.onStartup_vrxh3i_k$();
            element.addChild_2qpft2_k$(element_0);
          }
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (TextView())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          element.willAddChild_hz2iwc_k$(element_1);
          var tmp_1 = KMutableProperty0();
          var tmp_2 = TextView$_get_shown_$ref_kipsub(element_1);
          var tmp_3 = getPropertyCallableRef('shown', 0, tmp_1, tmp_2, TextView$_set_shown_$ref_l7jsq9(element_1));
          element_1.invoke_bnq13k_k$(tmp_3, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(value).isEmpty_y1axqb_k$());
          // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
          var tmp_4 = element_1.native_1;
          var tmp_5;
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength('Empty') === 0) {
            tmp_5 = '\xA0';
          } else {
            tmp_5 = 'Empty';
          }
          tmp_4.set_content_i5lrjv_k$(tmp_5);
          element_1.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          var this_0 = themed(element, ListSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_2 = new (RowOrCol())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element_2);
          this_0.willAddChild_hz2iwc_k$(element_2);
          element_2.set_vertical_nuap32_k$(true);
          var $this$col = element_2;
          reactive($this$col, VOID, ($this$reactive) => {
            $this$col.clearChildren_eufjq4_k$();
            // Inline function 'kotlin.collections.iterator' call
            var _iterator__ex2g4s = $this$reactive.invoke_r7m7el_k$(value).get_entries_p20ztl_k$().iterator_jk1svi_k$();
            while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
              var _destruct__k2r9zo = _iterator__ex2g4s.next_20eer_k$();
              // Inline function 'kotlin.collections.component1' call
              var entryKey = _destruct__k2r9zo.get_key_18j28a_k$();
              // Inline function 'kotlin.collections.component2' call
              var entryValue = _destruct__k2r9zo.get_value_j01efc_k$();
              var tmp = MapRenderer$form$lambda$lambda$lambda(entryKey);
              var keyLens = value.lens_u4wb4z_k$(tmp, MapRenderer$form$lambda$lambda$lambda_0(entryKey, entryValue));
              var tmp_0 = MapRenderer$form$lambda$lambda$lambda_1(entryValue);
              var valueLens = value.lens_u4wb4z_k$(tmp_0, MapRenderer$form$lambda$lambda$lambda_2(entryKey));
              // Inline function 'com.lightningkite.kiteui.views.card' call
              var this_0 = $this$col;
              // Inline function 'com.lightningkite.kiteui.views.direct.row' call
              var this_1 = themed(this_0, CardSemantic_getInstance());
              // Inline function 'com.lightningkite.kiteui.views.write' call
              var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
              ensureOutermostElement(element);
              this_1.willAddChild_hz2iwc_k$(element);
              element.set_vertical_nuap32_k$(false);
              // Inline function 'com.lightningkite.kiteui.views.expanding' call
              // Inline function 'com.lightningkite.kiteui.views.direct.col' call
              var this_2 = weight(element, 1.0);
              // Inline function 'com.lightningkite.kiteui.views.write' call
              var element_0 = new (RowOrCol())(this_2.get_context_h02k06_k$());
              ensureOutermostElement(element_0);
              this_2.willAddChild_hz2iwc_k$(element_0);
              element_0.set_vertical_nuap32_k$(true);
              subtext(element_0, 'Key');
              reactive(element_0, VOID, MapRenderer$form$lambda$lambda$lambda_3(element_0, selectedKeyRenderer, keyContext, keyLens, module_0));
              element_0.onStartup_vrxh3i_k$();
              this_2.addChild_2qpft2_k$(element_0);
              // Inline function 'com.lightningkite.kiteui.views.expanding' call
              // Inline function 'com.lightningkite.kiteui.views.direct.col' call
              var this_3 = weight(element, 1.0);
              // Inline function 'com.lightningkite.kiteui.views.write' call
              var element_1 = new (RowOrCol())(this_3.get_context_h02k06_k$());
              ensureOutermostElement(element_1);
              this_3.willAddChild_hz2iwc_k$(element_1);
              element_1.set_vertical_nuap32_k$(true);
              subtext(element_1, 'Value');
              reactive(element_1, VOID, MapRenderer$form$lambda$lambda$lambda_4(element_1, selectedValueRenderer, valueContext, valueLens, module_0));
              element_1.onStartup_vrxh3i_k$();
              this_3.addChild_2qpft2_k$(element_1);
              var keyToRemove = entryKey;
              // Inline function 'com.lightningkite.kiteui.views.direct.button' call
              var this_4 = get_centered(element);
              // Inline function 'com.lightningkite.kiteui.views.write' call
              var element_2 = new (Button())(this_4.get_context_h02k06_k$());
              ensureOutermostElement(element_2);
              this_4.willAddChild_hz2iwc_k$(element_2);
              // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
              var icon = Companion_getInstance().close_1.copy$default_cqy5mq_k$(get_rem(1), get_rem(1));
              // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
              // Inline function 'com.lightningkite.kiteui.views.write' call
              var element_3 = new (IconView())(element_2.get_context_h02k06_k$());
              ensureOutermostElement(element_3);
              element_2.willAddChild_hz2iwc_k$(element_3);
              element_3.set_source_3o5lkf_k$(icon);
              element_3.set_description_s1386w_k$('Remove');
              element_3.onStartup_vrxh3i_k$();
              element_2.addChild_2qpft2_k$(element_3);
              onClick(element_2, VOID, VOID, VOID, MapRenderer$form$lambda$lambda$slambda($this$reactive, value, keyToRemove));
              element_2.onStartup_vrxh3i_k$();
              this_4.addChild_2qpft2_k$(element_2);
              element.onStartup_vrxh3i_k$();
              this_1.addChild_2qpft2_k$(element);
            }
            return Unit_instance;
          });
          element_2.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element_2);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_3 = new (Button())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_3);
          element.willAddChild_hz2iwc_k$(element_3);
          var tmp0 = get_centered(element_3);
          // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
          var icon = Companion_getInstance().add_1.copy$default_cqy5mq_k$(get_rem(1), get_rem(1));
          // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_4 = new (IconView())(tmp0.get_context_h02k06_k$());
          ensureOutermostElement(element_4);
          tmp0.willAddChild_hz2iwc_k$(element_4);
          element_4.set_source_3o5lkf_k$(icon);
          element_4.set_description_s1386w_k$('Add');
          element_4.onStartup_vrxh3i_k$();
          tmp0.addChild_2qpft2_k$(element_4);
          onClick(element_3, VOID, VOID, VOID, MapRenderer$form$lambda$slambda(keySerializer, valueSerializer, value));
          element_3.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_3);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_s1o4lc_k$(context, value, module_0);
      }
      view_2ugbs1_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          var tmp = mapKeyElement(context.serializer_1);
          var keySerializer = (!(tmp == null) ? isInterface(tmp, KSerializer()) : false) ? tmp : THROW_CCE();
          var tmp_0 = mapValueElement(context.serializer_1);
          var valueSerializer = (!(tmp_0 == null) ? isInterface(tmp_0, KSerializer()) : false) ? tmp_0 : THROW_CCE();
          var keyContext = new (RenderContext())(keySerializer);
          var valueContext = new (RenderContext())(valueSerializer);
          var keyRenderers = module_0.selectAll_bhj9zi_k$(keyContext);
          var valueRenderers = module_0.selectAll_bhj9zi_k$(valueContext);
          var selectedKeyRenderer = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(module_0.selectWithOverride_muco3f_k$(keyContext));
          var selectedValueRenderer = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(module_0.selectWithOverride_muco3f_k$(valueContext));
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          element.set_gap_jwjroq_k$(get_px(0));
          if (module_0.enableRendererSwitching_1) {
            // Inline function 'com.lightningkite.kiteui.views.direct.row' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
            ensureOutermostElement(element_0);
            element.willAddChild_hz2iwc_k$(element_0);
            element_0.set_vertical_nuap32_k$(false);
            // Inline function 'com.lightningkite.kiteui.views.expanding' call
            var tmp$ret$8 = weight(element_0, 1.0);
            subrendererSelector(tmp$ret$8, selectedKeyRenderer, keyRenderers);
            // Inline function 'com.lightningkite.kiteui.views.expanding' call
            var tmp$ret$9 = weight(element_0, 1.0);
            subrendererSelector(tmp$ret$9, selectedValueRenderer, valueRenderers);
            element_0.onStartup_vrxh3i_k$();
            element.addChild_2qpft2_k$(element_0);
          }
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (TextView())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          element.willAddChild_hz2iwc_k$(element_1);
          var tmp_1 = KMutableProperty0();
          var tmp_2 = TextView$_get_shown_$ref_kipsub(element_1);
          var tmp_3 = getPropertyCallableRef('shown', 0, tmp_1, tmp_2, TextView$_set_shown_$ref_l7jsq9(element_1));
          element_1.invoke_bnq13k_k$(tmp_3, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(value).isEmpty_y1axqb_k$());
          // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
          var tmp_4 = element_1.native_1;
          var tmp_5;
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength('Empty') === 0) {
            tmp_5 = '\xA0';
          } else {
            tmp_5 = 'Empty';
          }
          tmp_4.set_content_i5lrjv_k$(tmp_5);
          element_1.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          var this_0 = themed(element, ListSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_2 = new (RowOrCol())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element_2);
          this_0.willAddChild_hz2iwc_k$(element_2);
          element_2.set_vertical_nuap32_k$(true);
          var $this$col = element_2;
          reactive($this$col, VOID, ($this$reactive) => {
            $this$col.clearChildren_eufjq4_k$();
            // Inline function 'kotlin.collections.iterator' call
            var _iterator__ex2g4s = $this$reactive.invoke_r7m7el_k$(value).get_entries_p20ztl_k$().iterator_jk1svi_k$();
            while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
              var _destruct__k2r9zo = _iterator__ex2g4s.next_20eer_k$();
              // Inline function 'kotlin.collections.component1' call
              var key = _destruct__k2r9zo.get_key_18j28a_k$();
              // Inline function 'kotlin.collections.component2' call
              var entryValue = _destruct__k2r9zo.get_value_j01efc_k$();
              // Inline function 'com.lightningkite.kiteui.views.card' call
              var this_0 = $this$col;
              // Inline function 'com.lightningkite.kiteui.views.direct.row' call
              var this_1 = themed(this_0, CardSemantic_getInstance());
              // Inline function 'com.lightningkite.kiteui.views.write' call
              var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
              ensureOutermostElement(element);
              this_1.willAddChild_hz2iwc_k$(element);
              element.set_vertical_nuap32_k$(false);
              // Inline function 'com.lightningkite.kiteui.views.expanding' call
              // Inline function 'com.lightningkite.kiteui.views.direct.col' call
              var this_2 = weight(element, 1.0);
              // Inline function 'com.lightningkite.kiteui.views.write' call
              var element_0 = new (RowOrCol())(this_2.get_context_h02k06_k$());
              ensureOutermostElement(element_0);
              this_2.willAddChild_hz2iwc_k$(element_0);
              element_0.set_vertical_nuap32_k$(true);
              subtext(element_0, 'Key');
              reactive(element_0, VOID, MapRenderer$view$lambda$lambda$lambda(element_0, selectedKeyRenderer, keyContext, key, module_0));
              element_0.onStartup_vrxh3i_k$();
              this_2.addChild_2qpft2_k$(element_0);
              // Inline function 'com.lightningkite.kiteui.views.expanding' call
              // Inline function 'com.lightningkite.kiteui.views.direct.col' call
              var this_3 = weight(element, 1.0);
              // Inline function 'com.lightningkite.kiteui.views.write' call
              var element_1 = new (RowOrCol())(this_3.get_context_h02k06_k$());
              ensureOutermostElement(element_1);
              this_3.willAddChild_hz2iwc_k$(element_1);
              element_1.set_vertical_nuap32_k$(true);
              subtext(element_1, 'Value');
              reactive(element_1, VOID, MapRenderer$view$lambda$lambda$lambda_0(element_1, selectedValueRenderer, valueContext, entryValue, module_0));
              element_1.onStartup_vrxh3i_k$();
              this_3.addChild_2qpft2_k$(element_1);
              element.onStartup_vrxh3i_k$();
              this_1.addChild_2qpft2_k$(element);
            }
            return Unit_instance;
          });
          element_2.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element_2);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_2ugbs1_k$(context, value, module_0);
      }
      cellView_ut6jrx_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => '' + $this$invoke.invoke_r7m7el_k$(value).get_size_woubt6_k$() + ' entries');
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      cellView_2dvin1_k$(context, value, module_0) {
        return this.cellView_ut6jrx_k$(context, value, module_0);
      }
      columnWidth_b1t3qn_k$(context, module_0) {
        return 10.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_b1t3qn_k$(context, module_0);
      }
      labeledForm_cqcgre_k$(context, value, module_0, label, description) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          element_0.set_vertical_nuap32_k$(false);
          h4(element_0, label);
          var tmp0_safe_receiver = description;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            var tmp0 = textPopover(get_centered(element_0), tmp0_safe_receiver);
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            var icon = Companion_getInstance().info_1.copy$default_cqy5mq_k$(get_rem(1), get_rem(1));
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_1 = new (IconView())(tmp0.get_context_h02k06_k$());
            ensureOutermostElement(element_1);
            tmp0.willAddChild_hz2iwc_k$(element_1);
            element_1.set_source_3o5lkf_k$(icon);
            element_1.set_description_s1386w_k$('Info');
            element_1.onStartup_vrxh3i_k$();
            tmp0.addChild_2qpft2_k$(element_1);
          }
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          MapRenderer_instance.form_s1o4lc_k$(context, value, module_0)(element);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      labeledForm_ughtr2_k$(context, value, module_0, label, description) {
        return this.labeledForm_cqcgre_k$(context, value, module_0, label, description);
      }
      labeledView_cw7u1l_k$(context, value, module_0, label, description) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          element_0.set_vertical_nuap32_k$(false);
          h4(element_0, label);
          var tmp0_safe_receiver = description;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            var tmp0 = textPopover(get_centered(element_0), tmp0_safe_receiver);
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            var icon = Companion_getInstance().info_1.copy$default_cqy5mq_k$(get_rem(1), get_rem(1));
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_1 = new (IconView())(tmp0.get_context_h02k06_k$());
            ensureOutermostElement(element_1);
            tmp0.willAddChild_hz2iwc_k$(element_1);
            element_1.set_source_3o5lkf_k$(icon);
            element_1.set_description_s1386w_k$('Info');
            element_1.onStartup_vrxh3i_k$();
            tmp0.addChild_2qpft2_k$(element_1);
          }
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          MapRenderer_instance.view_2ugbs1_k$(context, value, module_0)(element);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      labeledView_aldyvt_k$(context, value, module_0, label, description) {
        return this.labeledView_cw7u1l_k$(context, value, module_0, label, description);
      }
    }
    protoOf($).cellForm_4mayde_k$ = cellForm;
    initMetadataForObject($, 'MapRenderer', VOID, VOID, [Renderer()]);
    MapRendererClass = $;
  }
  return MapRendererClass;
}
var MapRenderer_instance;
function MapRenderer_getInstance() {
  return MapRenderer_instance;
}
//region block: init
MapRenderer_instance = new (MapRenderer())();
//endregion
//region block: exports
export {
  registerMap as registerMap2u9untf2jo1ee,
};
//endregion

//# sourceMappingURL=MapRenderer.mjs.map
